import { ReminderMailInfo } from '@/remindModule/entities/reminder';
import { deleteReminder, getAllReminders } from './driver';

/**
 * リマインドメール一覧から、同一の日付のものを取ってくる (配列?)
 * @param dateString - YYYYMMDDの8桁のstringで表された年月日情報
 */
export const getReminderByDate = async (dateString: string): Promise<ReminderMailInfo[]> => {
  const res = await getAllReminders();
  if (!res.success || !res.result.length) return [];
  // とりあえず年月日一致で取ってくる
  const info = res.result.filter((ent) => ent.date === dateString) as ReminderMailInfo[]; // TODO: asをなんとかしたい
  return info;
};

/**
 * リマインドメール一覧から、ログイン中のユーザーが登録を行なったものを取得する
 * @param userId ログインユーザーのメールアドレス
 */
export const getReminderByUser = async (userId: string) => {
  const res = await getAllReminders();
  if (!res.success || !res.result.length) return [];
  // TODO: メール送信先配列の先頭にリマインド登録者のアドレスがある想定で書いている。Bcc機能が追加されたら変更する
  const info = res.result.filter((ent) => ent.mailTo[0] === userId) as ReminderMailInfo[]; // TODO: asをなんとかしたい
  return info;
};

/**
 * 登録済みのリマインダー一覧をすべて削除する
 */
export const allReminderDelete = async () => {
  const res = await getAllReminders();
  if (!res.success || !res.result.length) return [];
  // とりあえず年月日一致で取ってくる
  const infoIds = res.result.map((ent) => ent.dataId) as string[]; // TODO: asをなんとかしたい
  for (const id of infoIds) {
    const res = await deleteReminder(id);
    console.log({ res: res });
  }
};
